import ReconnectingWebSocket from 'reconnecting-websocket';
import $store from "../store";
import { WS_Status } from "./constant";

let rws = null;
let globalCallback = null;
let manualClose = false;
let reconnectAttempts = 0;
const MAX_RECONNECT_ATTEMPTS = 30;
const RECONNECT_INTERVAL = 6000;

const heartCheck = {
  timeout: 13000,
  timeoutObj: null,
  start() {
    this.reset();
    this.timeoutObj = setInterval(() => {
      const token = $store.state.app.token.replace('Bearer ','');
      const liveId = $store.state.live.id;
      if (liveId && rws && rws.readyState === rws.OPEN) {
        const checkMsg = JSON.stringify({ msgCode: "heart", liveId, token });
        rws.send(checkMsg);
      }
    }, this.timeout);
  },
  reset() {
    clearInterval(this.timeoutObj);
    this.timeoutObj = null;
  },
};

const initWebsocket = (liveId) => {
  // 防止重复初始化
  if (rws && (rws.readyState === rws.OPEN || rws.readyState === rws.CONNECTING)) {
    console.log('WebSocket already initialized or connecting.');
    return;
  }
  manualClose = false;

  const token = $store.state.app.token.replace('bearer ','');
  // 【关键修改】将 token 拼接到 URL 参数中，而不是作为第二个参数（第二个参数是 sub-protocol，传 token 会导致握手失败）
  const url = `${process.env.VUE_APP_WS_URL}/chatImServer?client=h5&liveId=${liveId}&token=${token}`;

  rws = new ReconnectingWebSocket(url); // 【关键修改】移除第二个参数 token

  rws.addEventListener("open", () => {
    console.log("✅ WebSocket connection established");
    $store.commit('upWsStatus', WS_Status.connected);
    reconnectAttempts = 0;
    heartCheck.start();
  });

  rws.addEventListener("message", (e) => {
    heartCheck.reset();
    try {
      const parsedData = JSON.parse(e.data);
      if (globalCallback) {
        globalCallback(parsedData);
      }
    } catch (err) {
      console.error("Error parsing WebSocket message:", err);
    }
  });

  rws.addEventListener("error", (e) => {
    console.error("❌ WebSocket error:", e.message);
    $store.commit('upWsStatus', WS_Status.connected_err);
  });

  rws.addEventListener("close", (e) => {
    console.warn("🔌 WebSocket closed", e.code, e.reason);
    heartCheck.reset();
    $store.commit('upWsStatus', WS_Status.unconnected);
    if (!manualClose) {
      attemptReconnect(liveId);
    }
  });
};

const attemptReconnect = (liveId) => {
  if (manualClose || reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) return;
  reconnectAttempts++;
  setTimeout(() => initWebsocket(liveId), RECONNECT_INTERVAL);
};

// 【关键修改】彻底删除 listenToVisibilityChange 方法，唤醒逻辑统一由 App.vue 控制，避免竞态条件

const webSocketSend = (data) => {
  if (rws && rws.readyState === rws.OPEN) {
    rws.send(data);
  }
};

const webSocketClose = (manual = true) => {
  manualClose = manual;
  if (rws) {
    heartCheck.reset();
    rws.close();
    rws = null;
  }
  $store.commit('upWsStatus', WS_Status.connect_close);
};

const setMessageCallback = (callback) => {
  globalCallback = callback;
};

export { initWebsocket, webSocketClose, webSocketSend, setMessageCallback };
